var styleDataHash = "99028185";
const injectCss = () => {
  var css = `.O0uxU{height:18px;position:relative;width:18px}.EwH0w,.PuO5S{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .EwH0w,[dir=ltr] .PuO5S{left:0}[dir=rtl] .EwH0w,[dir=rtl] .PuO5S{right:0}.PuO5S{stroke:currentColor;opacity:.3}[dir=ltr] .PuO5S{animation:IWC3e 666ms linear infinite}[dir=rtl] .PuO5S{animation:d9zkf 666ms linear infinite}.EwH0w{stroke:currentColor}[dir=ltr] .EwH0w{animation:IWC3e 2s linear infinite}[dir=rtl] .EwH0w{animation:d9zkf 2s linear infinite}@keyframes IWC3e{to{transform:rotate(1turn)}}@keyframes d9zkf{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "O0uxU",
  "top": "PuO5S",
  "bottom": "EwH0w",
  "rotation-ltr": "IWC3e",
  "rotation-rtl": "d9zkf"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
